//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IConfigurationCurrentValueClient {
    /**
     * Gibt die Liste aller Konfigurations-Vorgabe-Daten zurück
     * @return Konfigurations-Vorgabe-Liste
     */
    get(): Observable<ApiConfigurationCurrentValue[]>;
    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiConfigurationCurrentValues Neue Konfigurations-Vorgabe-Daten
     * @return Task-OK
     */
    update(apiConfigurationCurrentValues: ApiConfigurationCurrentValue[]): Observable<void>;
}

@Injectable()
export class ConfigurationCurrentValueClient implements IConfigurationCurrentValueClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste aller Konfigurations-Vorgabe-Daten zurück
     * @return Konfigurations-Vorgabe-Liste
     */
    get(): Observable<ApiConfigurationCurrentValue[]> {
        let url_ = this.baseUrl + "/api/ConfigurationCurrentValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiConfigurationCurrentValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiConfigurationCurrentValue[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiConfigurationCurrentValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiConfigurationCurrentValue[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiConfigurationCurrentValues Neue Konfigurations-Vorgabe-Daten
     * @return Task-OK
     */
    update(apiConfigurationCurrentValues: ApiConfigurationCurrentValue[]): Observable<void> {
        let url_ = this.baseUrl + "/api/ConfigurationCurrentValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiConfigurationCurrentValues);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationPredefinedValueClient {
    /**
     * Gibt die Liste aller Konfigurations-Vorgabe-Daten zurück
     * @return Konfigurations-Vorgabe-Liste
     */
    getAll(): Observable<ApiConfigurationPredefinedValue[]>;
    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiConfigurationPredefinedValue Neue Konfigurations-Vorgabe-Daten
     * @return Task-OK
     */
    update(apiConfigurationPredefinedValue: ApiConfigurationPredefinedValue): Observable<void>;
}

@Injectable()
export class ConfigurationPredefinedValueClient implements IConfigurationPredefinedValueClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste aller Konfigurations-Vorgabe-Daten zurück
     * @return Konfigurations-Vorgabe-Liste
     */
    getAll(): Observable<ApiConfigurationPredefinedValue[]> {
        let url_ = this.baseUrl + "/api/ConfigurationPredefinedValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiConfigurationPredefinedValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiConfigurationPredefinedValue[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiConfigurationPredefinedValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiConfigurationPredefinedValue[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiConfigurationPredefinedValue Neue Konfigurations-Vorgabe-Daten
     * @return Task-OK
     */
    update(apiConfigurationPredefinedValue: ApiConfigurationPredefinedValue): Observable<void> {
        let url_ = this.baseUrl + "/api/ConfigurationPredefinedValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiConfigurationPredefinedValue);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDirectSettlingLocationClient {
    /**
     * Gibt die Liste der Direktverrechnungs-Standort-Daten zurück
     * @return Direktverrechnungs-Standort-Liste
     */
    getDirectSettlingLocation(): Observable<ApiDirectSettlingLocation[]>;
    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiDirectSettlingLocation Die neuen Direktverrechnungs-Standort-Daten
     * @return Task-OK
     */
    update(apiDirectSettlingLocation: ApiDirectSettlingLocation): Observable<void>;
    /**
     * Erlaubt den Import von Direktverrechnungs-Standort-Daten über ein Excel-Template
     * @param file (optional) Das Upload File
     * @return Das Upload-Result
     */
    uploadDsLFromExcel(file: FileParameter | null | undefined): Observable<string>;
    /**
     * Gibt einen Direktverrechnungs-Standort über die Id zurück
     * @param request Id des Direktverrechnungs-Standortes
     * @return Radio-Objekt
     */
    getById(request: ApiDirectSettlingLocation, id: string): Observable<void>;
}

@Injectable()
export class DirectSettlingLocationClient implements IDirectSettlingLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste der Direktverrechnungs-Standort-Daten zurück
     * @return Direktverrechnungs-Standort-Liste
     */
    getDirectSettlingLocation(): Observable<ApiDirectSettlingLocation[]> {
        let url_ = this.baseUrl + "/api/DirectSettlingLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectSettlingLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectSettlingLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiDirectSettlingLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiDirectSettlingLocation[]>;
        }));
    }

    protected processGetDirectSettlingLocation(response: HttpResponseBase): Observable<ApiDirectSettlingLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiDirectSettlingLocation[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiDirectSettlingLocation Die neuen Direktverrechnungs-Standort-Daten
     * @return Task-OK
     */
    update(apiDirectSettlingLocation: ApiDirectSettlingLocation): Observable<void> {
        let url_ = this.baseUrl + "/api/DirectSettlingLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiDirectSettlingLocation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Erlaubt den Import von Direktverrechnungs-Standort-Daten über ein Excel-Template
     * @param file (optional) Das Upload File
     * @return Das Upload-Result
     */
    uploadDsLFromExcel(file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/DirectSettlingLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDsLFromExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDsLFromExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadDsLFromExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gibt einen Direktverrechnungs-Standort über die Id zurück
     * @param request Id des Direktverrechnungs-Standortes
     * @return Radio-Objekt
     */
    getById(request: ApiDirectSettlingLocation, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/DirectSettlingLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHashClient {
    /**
     * Gibt den gehashten Wert zurück
     * @param stringToHash Id des Funkstroms
     * @return Hash-Wert
     */
    getHashString(stringToHash: string | null): Observable<void>;
}

@Injectable()
export class HashClient implements IHashClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt den gehashten Wert zurück
     * @param stringToHash Id des Funkstroms
     * @return Hash-Wert
     */
    getHashString(stringToHash: string | null): Observable<void> {
        let url_ = this.baseUrl + "/HashData/{stringToHash}";
        if (stringToHash === undefined || stringToHash === null)
            throw new Error("The parameter 'stringToHash' must be defined.");
        url_ = url_.replace("{stringToHash}", encodeURIComponent("" + stringToHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHashString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHashString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetHashString(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPueExportClient {
    /**
     * Methode für den Excel-Export der PUE Monats- oder der Pue Jahreswerte
     * @param weId (optional) Die übergebene Wirtschaftseinheit.
     * @param year (optional) Das Jahr, für das der Export durchgeführt werden soll.
     * @param month (optional) Der Monat der Exportiert werden soll. Wenn der null ist wird das Jahr exportiert
     * @return Die generierte Excel-Datei als Download im Browser.
     */
    downloadPueValues(weId: string | null | undefined, year: number | undefined, month: number | null | undefined): Observable<FileResponse | null>;
}

@Injectable()
export class PueExportClient implements IPueExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Methode für den Excel-Export der PUE Monats- oder der Pue Jahreswerte
     * @param weId (optional) Die übergebene Wirtschaftseinheit.
     * @param year (optional) Das Jahr, für das der Export durchgeführt werden soll.
     * @param month (optional) Der Monat der Exportiert werden soll. Wenn der null ist wird das Jahr exportiert
     * @return Die generierte Excel-Datei als Download im Browser.
     */
    downloadPueValues(weId: string | null | undefined, year: number | undefined, month: number | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PueExport?";
        if (weId !== undefined && weId !== null)
            url_ += "weId=" + encodeURIComponent("" + weId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPueValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPueValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadPueValues(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPueMonthClient {
    /**
     * Gibt alle Pue-Monatsdaten über die We-Id
     * @param weId We-Id
     * @return Liste der PueMonats-Daten
     */
    get(weId: string | null): Observable<ApiPueMonth[]>;
}

@Injectable()
export class PueMonthClient implements IPueMonthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt alle Pue-Monatsdaten über die We-Id
     * @param weId We-Id
     * @return Liste der PueMonats-Daten
     */
    get(weId: string | null): Observable<ApiPueMonth[]> {
        let url_ = this.baseUrl + "/api/PueMonth/{weId}";
        if (weId === undefined || weId === null)
            throw new Error("The parameter 'weId' must be defined.");
        url_ = url_.replace("{weId}", encodeURIComponent("" + weId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiPueMonth[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiPueMonth[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPueMonth[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiPueMonth[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPueYearClient {
    /**
     * Gibt alle Pue-Jahreswerte über die WeId zurück
     * @param id WeId
     * @return PueJahres-Objekt
     */
    getById(id: string | null): Observable<ApiPueYear[]>;
}

@Injectable()
export class PueYearClient implements IPueYearClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt alle Pue-Jahreswerte über die WeId zurück
     * @param id WeId
     * @return PueJahres-Objekt
     */
    getById(id: string | null): Observable<ApiPueYear[]> {
        let url_ = this.baseUrl + "/api/PueYear/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiPueYear[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiPueYear[]>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ApiPueYear[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiPueYear[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRadioClient {
    /**
     * Gibt die Liste der Funkstrom-Werte zurück
     * @return Funkstrom-Liste
     */
    getRadios(): Observable<ApiRadio[]>;
    /**
     * Fügt dem Datenbestand ein Liste von Funkstrom-Daten hinzu
     * @param apiRadios Die einzufügenden Funkstrom-Daten per Liste
     * @return Die hinzugefügte Funkstrom-Daten
     */
    add(apiRadios: ApiRadio[]): Observable<ApiRadio[]>;
    /**
     * Modifiziert bereits existierende Datensätze per Liste
     * @param apiRadios Die neuen Funkstrom-Daten
     * @return Task-OK
     */
    update(apiRadios: ApiRadio[]): Observable<void>;
    /**
     * Gibt eine Funkstromwert über die Id zurück
     * @param request Id des Funkstroms
     * @return Radio-Objekt
     */
    getById(request: ApiRadio, id: string): Observable<void>;
    /**
     * Löscht einen Funkstrom-Wert
     * @param id ID des Funkstrom-Wertes
     * @return HTTP 204 - No content
     */
    deleteById(id: string | null): Observable<void>;
}

@Injectable()
export class RadioClient implements IRadioClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste der Funkstrom-Werte zurück
     * @return Funkstrom-Liste
     */
    getRadios(): Observable<ApiRadio[]> {
        let url_ = this.baseUrl + "/api/Radio";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRadios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRadios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiRadio[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiRadio[]>;
        }));
    }

    protected processGetRadios(response: HttpResponseBase): Observable<ApiRadio[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiRadio[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fügt dem Datenbestand ein Liste von Funkstrom-Daten hinzu
     * @param apiRadios Die einzufügenden Funkstrom-Daten per Liste
     * @return Die hinzugefügte Funkstrom-Daten
     */
    add(apiRadios: ApiRadio[]): Observable<ApiRadio[]> {
        let url_ = this.baseUrl + "/api/Radio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiRadios);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiRadio[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiRadio[]>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiRadio[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiRadio[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert bereits existierende Datensätze per Liste
     * @param apiRadios Die neuen Funkstrom-Daten
     * @return Task-OK
     */
    update(apiRadios: ApiRadio[]): Observable<void> {
        let url_ = this.baseUrl + "/api/Radio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiRadios);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gibt eine Funkstromwert über die Id zurück
     * @param request Id des Funkstroms
     * @return Radio-Objekt
     */
    getById(request: ApiRadio, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Radio/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Löscht einen Funkstrom-Wert
     * @param id ID des Funkstrom-Wertes
     * @return HTTP 204 - No content
     */
    deleteById(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Radio/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISmopsValidationClient {
    /**
     * Löst die Validierung und Historisierung der Daten im Affinis.EDB- BE aus
     * @return Ok-Status-Code
     */
    startValidation(): Observable<void>;
}

@Injectable()
export class SmopsValidationClient implements ISmopsValidationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Löst die Validierung und Historisierung der Daten im Affinis.EDB- BE aus
     * @return Ok-Status-Code
     */
    startValidation(): Observable<void> {
        let url_ = this.baseUrl + "/Validation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartValidation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserDefinedAdjustmentsClient {
    /**
     * Gibt die Liste der User-Korrektur-Daten zurück
     * @return Korrekturdaten-Liste
     */
    getAll(): Observable<ApiUserDefinedAdjustments[]>;
    /**
     * Fügt dem Datenbestand einen Datensatz für die User-Korrektur-Daten hinzu
     * @param apiUserDefinedAdjustments Die hinzuzufügende User-Korrektur-Satz
     * @return Die hinzugefügte User-Korrekturwert
     */
    add(apiUserDefinedAdjustments: ApiUserDefinedAdjustments): Observable<ApiUserDefinedAdjustments>;
    /**
     * Gibt einen User-Korrektur-Wert über die Id zurück
     * @param uDaId (optional) Id des User-Korrektur-Werts
     * @return Korrekturdaten-Objekt
     */
    getById(uDaId: string | null | undefined, id: string): Observable<void>;
    /**
     * Modifiziert einen bereits existierenden Datensatz für die User-Korrektur-Daten
     * @param apiUserDefinedAdjustments Die neuen Daten
     * @return Die geänderten Daten
     */
    update(apiUserDefinedAdjustments: ApiUserDefinedAdjustments, id: string): Observable<void>;
    /**
     * Löscht eine User-Korrektur-Wert
     * @param id ID der zu löschenden Plattform
     * @return HTTP 204 - No content oder 404 - Not Found
     */
    deleteById(id: string | null): Observable<void>;
}

@Injectable()
export class UserDefinedAdjustmentsClient implements IUserDefinedAdjustmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste der User-Korrektur-Daten zurück
     * @return Korrekturdaten-Liste
     */
    getAll(): Observable<ApiUserDefinedAdjustments[]> {
        let url_ = this.baseUrl + "/api/UserDefinedAdjustments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiUserDefinedAdjustments[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiUserDefinedAdjustments[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiUserDefinedAdjustments[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiUserDefinedAdjustments[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fügt dem Datenbestand einen Datensatz für die User-Korrektur-Daten hinzu
     * @param apiUserDefinedAdjustments Die hinzuzufügende User-Korrektur-Satz
     * @return Die hinzugefügte User-Korrekturwert
     */
    add(apiUserDefinedAdjustments: ApiUserDefinedAdjustments): Observable<ApiUserDefinedAdjustments> {
        let url_ = this.baseUrl + "/api/UserDefinedAdjustments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiUserDefinedAdjustments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiUserDefinedAdjustments>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiUserDefinedAdjustments>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiUserDefinedAdjustments> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiUserDefinedAdjustments;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gibt einen User-Korrektur-Wert über die Id zurück
     * @param uDaId (optional) Id des User-Korrektur-Werts
     * @return Korrekturdaten-Objekt
     */
    getById(uDaId: string | null | undefined, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedAdjustments/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (uDaId !== undefined && uDaId !== null)
            url_ += "uDaId=" + encodeURIComponent("" + uDaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert einen bereits existierenden Datensatz für die User-Korrektur-Daten
     * @param apiUserDefinedAdjustments Die neuen Daten
     * @return Die geänderten Daten
     */
    update(apiUserDefinedAdjustments: ApiUserDefinedAdjustments, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedAdjustments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiUserDefinedAdjustments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Löscht eine User-Korrektur-Wert
     * @param id ID der zu löschenden Plattform
     * @return HTTP 204 - No content oder 404 - Not Found
     */
    deleteById(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedAdjustments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserDefinedValuesClient {
    /**
     * Gibt die Liste der User-Vorgabe-Daten zurück
     * @return User-VorgabeDaten-Liste
     */
    getAll(): Observable<ApiUserDefinedValues[]>;
    /**
     * Fügt dem Datenbestand einen Datensatz für die User-Vorgabe-Daten hinzu
     * @param apiUserDefinedValues Die hinzuzufügende User-Vorgabe-Satz
     * @return Die hinzugefügte User-Vorgabe
     */
    add(apiUserDefinedValues: ApiUserDefinedValues): Observable<ApiUserDefinedValues>;
    /**
     * Gibt einen User-Vorgabe-Wert über die Id zurück
     * @param uDvId (optional) Id des User-Vorgabe-Werts
     * @return User-Vorgabe-Objekt
     */
    getById(uDvId: string | null | undefined, id: string): Observable<void>;
    /**
     * Modifiziert einen bereits existierenden Datensatz für die User-Vorgabe-Daten
     * @param id Die Id zum vorhandenen Datensatz
     * @param apiUserDefinedValues Die neuen Daten
     * @return Die geänderten Daten
     */
    update(id: string | null, apiUserDefinedValues: ApiUserDefinedValues): Observable<void>;
    /**
     * Löscht eine User-Vorgabe-Wert
     * @param id ID des User-Vorgabe-Wertes
     * @return HTTP 204 - No content
     */
    deleteById(id: string | null): Observable<void>;
}

@Injectable()
export class UserDefinedValuesClient implements IUserDefinedValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gibt die Liste der User-Vorgabe-Daten zurück
     * @return User-VorgabeDaten-Liste
     */
    getAll(): Observable<ApiUserDefinedValues[]> {
        let url_ = this.baseUrl + "/api/UserDefinedValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiUserDefinedValues[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiUserDefinedValues[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiUserDefinedValues[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiUserDefinedValues[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fügt dem Datenbestand einen Datensatz für die User-Vorgabe-Daten hinzu
     * @param apiUserDefinedValues Die hinzuzufügende User-Vorgabe-Satz
     * @return Die hinzugefügte User-Vorgabe
     */
    add(apiUserDefinedValues: ApiUserDefinedValues): Observable<ApiUserDefinedValues> {
        let url_ = this.baseUrl + "/api/UserDefinedValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiUserDefinedValues);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiUserDefinedValues>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiUserDefinedValues>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiUserDefinedValues> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiUserDefinedValues;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gibt einen User-Vorgabe-Wert über die Id zurück
     * @param uDvId (optional) Id des User-Vorgabe-Werts
     * @return User-Vorgabe-Objekt
     */
    getById(uDvId: string | null | undefined, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedValues/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (uDvId !== undefined && uDvId !== null)
            url_ += "uDvId=" + encodeURIComponent("" + uDvId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert einen bereits existierenden Datensatz für die User-Vorgabe-Daten
     * @param id Die Id zum vorhandenen Datensatz
     * @param apiUserDefinedValues Die neuen Daten
     * @return Die geänderten Daten
     */
    update(id: string | null, apiUserDefinedValues: ApiUserDefinedValues): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedValues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiUserDefinedValues);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Löscht eine User-Vorgabe-Wert
     * @param id ID des User-Vorgabe-Wertes
     * @return HTTP 204 - No content
     */
    deleteById(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/UserDefinedValues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWeClient {
    /**
     * Sucht Wirtschaftseinheiten anhand des angegebenen Textes.
     * @param text (optional) Text nach dem gesucht werden soll.
     * @return Eine Liste von Wirtschaftseinheiten die dem gesuchten Text entsprechen.
     */
    find(text: string | null | undefined): Observable<ApiWe[]>;
    /**
     * Gibt eine Wirtschaftseinheit über die Id zurück
     * @param weId (optional) Id der WE
     * @return We-Objekt
     */
    getById(weId: string | null | undefined): Observable<ApiWe>;
    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiWeList Die neuen We-Daten
     * @return Task-OK
     */
    update(apiWeList: ApiWe[]): Observable<void>;
}

@Injectable()
export class WeClient implements IWeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Sucht Wirtschaftseinheiten anhand des angegebenen Textes.
     * @param text (optional) Text nach dem gesucht werden soll.
     * @return Eine Liste von Wirtschaftseinheiten die dem gesuchten Text entsprechen.
     */
    find(text: string | null | undefined): Observable<ApiWe[]> {
        let url_ = this.baseUrl + "/api/We/Find?";
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFind(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFind(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiWe[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiWe[]>;
        }));
    }

    protected processFind(response: HttpResponseBase): Observable<ApiWe[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiWe[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gibt eine Wirtschaftseinheit über die Id zurück
     * @param weId (optional) Id der WE
     * @return We-Objekt
     */
    getById(weId: string | null | undefined): Observable<ApiWe> {
        let url_ = this.baseUrl + "/api/We/Id?";
        if (weId !== undefined && weId !== null)
            url_ += "weId=" + encodeURIComponent("" + weId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiWe>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiWe>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ApiWe> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiWe;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Modifiziert bereits existierende Datensätze
     * @param apiWeList Die neuen We-Daten
     * @return Task-OK
     */
    update(apiWeList: ApiWe[]): Observable<void> {
        let url_ = this.baseUrl + "/api/We";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiWeList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Basisklasse für alle API Objekte mit ID. */
export interface ApiEntity {
    /** Eindeutige ID des Objektes. */
    id: string;
}

/** Diese Tabelle enthält die aktuellen Configurations-Werte für User-Einstellungen */
export interface ApiConfigurationCurrentValue extends ApiEntity {
    /** Der Typ der aktuellen Configuration */
    type: number;
    /** Der Wert des Configurationsettings */
    value: number;
    /** Das Flag, welches anzeigt, ob dieser Wert überhaupt genutzt wird , 0 == nein, 1 == ja */
    usesPredefinedValue: number;
}

/** Diese Tabelle enthält die vordefinierten ConfigurationsWerte */
export interface ApiConfigurationPredefinedValue extends ApiEntity {
    /** Der Typ der aktuellen Configuration */
    currentValuesId: string;
    /** Der Wert des Configurationsettings */
    value: number;
}

/** Diese Tabelle enthält die Funkstrom-Daten */
export interface ApiDirectSettlingLocation {
    /** Die eindeutige Id des Datensatzes erzeugt als Hashkey */
    id: string;
    /** Die Wirtschaftseinheit ohne führende Nullen */
    normalizedWe: string;
    /** Wirtschaftseinheit Id, als FK geliefert als HashKey */
    weId: string;
    /** Ort der Abrechnungs-Location */
    city?: string | undefined;
    /** Postleitzahl */
    postcode?: string | undefined;
    /** Straße (inkl. Hausnummer). */
    street?: string | undefined;
    /** Die Kategorie des Abrechnungs-Standortes */
    category?: string | undefined;
    /** Die Anlagen-Nummer */
    meterEquipmentNr?: string | undefined;
    /** Die Ablese-Einheit */
    readingUnit?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Das Api Modell für die Korrekturwerte */
export interface ApiPueMonth {
    /** Die eindeutige Id des Datensatzes */
    id: string;
    /** Die WE_ID for FK */
    weId: string;
    /** Das Jahr der Betrachtung */
    year: number;
    /** Enum-Id des Monats */
    monthTypeEnumerationId: number;
    /** Der monatliche Verbrauch in kWh */
    consumptionkWh?: number | undefined;
    /** Unverteiler-Unterzähler-Messwert in kWh */
    dfmgUvtUzkWh?: number | undefined;
    /** Die Energie-Erzeugung in kWh */
    powerGenerationValuekWh?: number | undefined;
    /** Der Gebäude-Verbrauch in kWh */
    buildingEnergykWh?: number | undefined;
    /** Die Kollokation Energie in kWh */
    kolloEnergykWh?: number | undefined;
    /** Der Unterzähler-Messwert in kWh */
    subMeterkWh?: number | undefined;
    /** Der Wert NN für EMobility in kWh */
    emobNnkWh?: number | undefined;
    /** Der EMobility Unterzählerwert in kWh */
    emobUzkWh?: number | undefined;
    /** Der Unterverteiler Pauschal Wert in kWh */
    dfmgUvtFlatkWh?: number | undefined;
    /** Externe Energie für NF3 in kWh */
    extEnergyNf3kWh?: number | undefined;
    /** Der Kets Wert in kWh */
    ketskWh?: number | undefined;
    /** Der Verbrauchswert zur Fsp in kWh */
    mvFspkWh?: number | undefined;
    /** Funktstrom Wert 'TD' in kWh */
    radioEnergyTdkWh?: number | undefined;
    /** Der Leistungswert zum Typ Ugv in kW */
    mvUgvkW?: number | undefined;
    /** Der Leistungswert zum Typ UWV in kW */
    mvUwvkW?: number | undefined;
    /** Der Leistungswert im Stadtnetz in kW */
    mvCityNetkW?: number | undefined;
    /** Der Reduzierte Leistungswert zum Typ UWV im Stadtnetz in kW */
    mvUwvCityNetRedkW?: number | undefined;
    /** Der Reduzierte Leistungswert zum Typ UWV in kW */
    mvRedUwvkW?: number | undefined;
    /** Der Reduzierte Leistungswert im Stadtnetz in kW */
    mvRedCityNetkW?: number | undefined;
    /** Der Messwert zum Typ G230 in kW */
    mvG230kW?: number | undefined;
    /** Der Verbrauschwert für den mobilen Funktstrom in kWh */
    mobileRadiokWh?: number | undefined;
    /** Der Eingabewert in kWh */
    inputkWh?: number | undefined;
    /** Der Output Wert in kWh */
    outputkWh?: number | undefined;
    /** Der Pue -Wert */
    pue?: number | undefined;
}

/** Das Api Modell für die Jahreswerte */
export interface ApiPueYear {
    /** Die eindeutige Id des Datensatzes erzeugt als Hashkey */
    id: string;
    /** Das betrachtete Jahr */
    year: number;
    /** Der monatliche Verbrauch in kWh */
    consumptionkWh?: number | undefined;
    /** Unverteiler-Unterzähler-Messwert in kWh */
    dfmgUvtUzkWh?: number | undefined;
    /** Die Energie-Erzeugung in kWh */
    powerGenerationValuekWh?: number | undefined;
    /** Der Gebäude-Verbrauch in kWh */
    buildingEnergykWh?: number | undefined;
    /** Die Kollokation Energie in kWh */
    kolloEnergykWh?: number | undefined;
    /** Der Unterzähler-Messwert in kWh */
    subMeterkWh?: number | undefined;
    /** Der Wert NN für EMobility in kWh */
    emobNnkWh?: number | undefined;
    /** Der EMobility Unterzählerwert in kWh */
    emobUzkWh?: number | undefined;
    /** Der Unterverteiler Pauschal Wert in kWh */
    dfmgUvtFlatkWh?: number | undefined;
    /** Externe Energie für NF3 in kWh */
    extEnergyNf3kWh?: number | undefined;
    /** Der Kets Wert in kWh */
    ketskWh?: number | undefined;
    /** Der Verbrauchswert zur Fsp in kWh */
    mvFspkWh?: number | undefined;
    /** Funktstrom Wert 'TD' in kWh */
    radioEnergyTdkWh?: number | undefined;
    /** Der Leistungswert zum Typ Ugv in kW */
    mvUgvkW?: number | undefined;
    /** Der Leistungswert zum Typ UWV in kW */
    mvUwvkW?: number | undefined;
    /** Der Leistungswert im Stadtnetz in kW */
    mvCityNetkW?: number | undefined;
    /** Der Reduzierte Leistungswert zum Typ UWV im Stadtnetz in kW */
    mvUwvCityNetRedkW?: number | undefined;
    /** Der Reduzierte Leistungswert zum Typ UWV in kW */
    mvRedUwvkW?: number | undefined;
    /** Der Reduzierte Leistungswert im Stadtnetz in kW */
    mvRedCityNetkW?: number | undefined;
    /** Der Messwert zum Typ G230 in kW */
    mvG230kW?: number | undefined;
    /** Der Verbrauschwert für den mobilen Funktstrom in kWh */
    mobileRadiokWh?: number | undefined;
    /** Der Eingabewert in kWh */
    inputkWh?: number | undefined;
    /** Der Output Wert in kWh */
    outputkWh?: number | undefined;
    /** Der Pue -Wert */
    pue?: number | undefined;
}

/** Diese Tabelle enthält die Funkstrom-Daten */
export interface ApiRadio {
    /** Die eindeutige Id des Datensatzes erzeugt als Hashkey */
    id: string;
    /** Enum-Id des Monats */
    monthTypeEnumerationId: number;
    /** Das Jahr der Betrachtung */
    year: number;
    /** Der Pue Funkstrom Wert */
    pueRadio?: number | undefined;
}

/** Dieses Model enthält die User-Korrektur-Werte */
export interface ApiUserDefinedAdjustments {
    /** Eindeutige ID der Benutzerdefinierten Anpassungen. */
    id: string;
    /** Beschreibung für die benutzerdefinierten Anpassungen. */
    description?: string | undefined;
    /** Enum-Id des Monats */
    monthTypeEnumerationId: number;
    /** Anpassung des Inputs in kWh. */
    inputAdjustmentkWh?: number | undefined;
    /** Anpassung des Outputs in kW. */
    outputAdjustmentkW?: number | undefined;
    /** Anpassung des Outputs in kWh. */
    outputAdjustmentkWh?: number | undefined;
    /** Id der Wirtschaftseinheit für die die Anpassungen gelten. */
    weId: string;
    /** Nummer der zugehörigen Wirtschaftseinheit */
    weNumber: string;
    /** Das Jahr für das die Anpassungen gültig sind */
    year: number;
}

/** Dieses Model enthält die User-Vorgabe-Werte */
export interface ApiUserDefinedValues {
    /** Eindeutige ID der Benutzerdefinierten Werte. */
    id: string;
    /** Der Bestell-Messwert Factor */
    bwFactor?: number | undefined;
    /** Der Stadtnetz Factor */
    cityNetFactor?: number | undefined;
    /** Der Cop Belüftungs Faktor */
    copAirFactor?: number | undefined;
    /** Der CopSplit Faktor */
    copSplitFactor?: number | undefined;
    /** Der Fsp Factor zur Berechnung */
    fspFactor?: number | undefined;
    /** NF3-Faktor */
    nf3Factor?: number | undefined;
    /** Das Jahr für das die Werte gelten. */
    year: number;
}

/** Wirtschaftseinheit. */
export interface ApiWe {
    /** Ort der Wirtschaftseinheit. */
    city?: string | undefined;
    /** ID der Wirtschaftseinheit bei der DFMG (Deutsche Funkturm GmbH). */
    dfmgId?: string | undefined;
    /** Kennzeichen, ob die Wirtschaftseinheit für DFMG Benutzer sichtbar sein soll. */
    dfmgFlag: boolean;
    /** Hierarchieebene der Wirtschaftseinheit. */
    hierarchy?: string | undefined;
    /** Eindeutige ID der Wirtschaftseinheit. */
    id: string;
    /** Nummer der Wirtschaftseinheit ohne führende Nullen. */
    normalizedNumber: string;
    /** Postleitzahl. */
    postcode?: string | undefined;
    /** Zusammengesetzter Text für die Suche. */
    searchString?: string | undefined;
    /** Anzahl Sterne. */
    stars?: number | undefined;
    /** Straße (inkl. Hausnummer). */
    street?: string | undefined;
    /** ID der Wirtschaftseinheit bei der TMD. */
    tmdId?: string | undefined;
    /** Sector / Sparte der Wirtschaftseinheit. */
    sector?: string | undefined;
    /** Kennzeichen, ob die Wirtschaftseinheit für T-Systems Benutzer sichtbar sein soll. */
    tSystemsFlag: boolean;
    /** Kennzeichen, ob die Wirtschaftseinheit auf der White List steht. */
    whiteListFlag: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}